// Tiny class-name combiner. Avoids pulling clsx/tailwind-merge as deps; the
// dashboard only needs conditional + space-joined class composition, with
// later values winning for the same key (object form).
export type ClassValue = string | false | null | undefined | Record<string, boolean | null | undefined>

export function cx(...parts: ClassValue[]): string {
  const out: string[] = []
  for (const part of parts) {
    if (!part) continue
    if (typeof part === 'string') {
      out.push(part)
      continue
    }
    for (const [key, value] of Object.entries(part)) {
      if (value) out.push(key)
    }
  }
  return out.join(' ')
}
